<script setup>
    import { useDisclosureCounselingReportStore } from '@/stores/disclosureCounseling/disclosureCounselingReportStore';
    import { useCommonStore } from '@/stores/common/commonStore';
    import { computed, inject, onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import { useHead } from 'unhead';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // ストア取得
    const reportStore = useDisclosureCounselingReportStore();
    const commonStore = useCommonStore();

    const router = useRoute();
    const sessionGrpPk = router.params.sessionGrpPk;
    const reservationPk = router.params.reservationPk;

    /**
     * 開示カウンセリングレポート取得処理
     */
    async function getDisclosureCounselingReport() {
        const queryParam = {
            SessionGrpPk: sessionGrpPk,
            ReservationPk: reservationPk,
        };
        const response = await reportStore.getDisclosureCounselingReportAction(commonStore.API_URL, queryParam);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        // 報告書用の専用スタイルを設定する。
        useHead({
            bodyAttrs: {
                class: 'report',
            },
        });
        
        await commonStore.getDomain();
        // reset();
        await getDisclosureCounselingReport();
    });

    const isCheckDisp = computed(() => (list, value) => {
        if (list !== undefined) {
            return list.find((data) => data === value) === undefined ? '□' : '☒';
        } else {
            return '';
        }
    });

    const checkDisp = computed(() => (bool) => {
        return bool === true ? '☒' : '□';
    });

    const useCount = computed(() => (list) => {
        return list !== undefined ? list.length : 0;
    });

    const isReportReturnToWorkSupport = computed(() => {
        return reportStore.RepType === '1' ? true : false;
    });

    /**
     * YYYY/MM/DDをYYYY年MM月DD日として返す。
     * @param {String} ymd YYYY/MM/DD
     */
    function dateDisp(ymd) {
        if (ymd) {
            var result = ymd;
            result = result.replace('/', '年');
            result = result.replace('/', '月');
            return result + '日';
        }
    }

    /**
     * 初期化する。
     */
    // function reset() {
    //     reportStore.reset();
    // }
</script>
<template>
    <section id="main">
        <div id="contents">
            <section class="reportContentBody" style="width: 100%">
                <h3 class="title">
                    <span>{{ $t('disclosureCounselingReport.parts.pageTitle1') }}</span>
                </h3>
                <section class="reportContents medium form" v-if="isReportReturnToWorkSupport" style="width: 1160px; min-width: 1160px;">
                    <span id="reportDate">{{ dateDisp(reportStore.RepData1.RepDate) }}</span>
                    <span id="reportFromName" class="underline">{{ $t('disclosureCounselingReport.parts.pageResponsible1') }}{{ reportStore.RepData1.AssignedNm }}</span>
                    <span id="reportToName" class="underline">{{ $t('disclosureCounselingReport.parts.pageAddress1') }}</span>
                    <p id="reportInfo">
                        {{ $t('disclosureCounselingReport.parts.pageAddressMessage1') }}<br />{{ $t('disclosureCounselingReport.parts.pageAddressMessage2') }}<br />{{ $t('disclosureCounselingReport.parts.pageAddressMessage3') }} <span class="underline">{{ reportStore.RepData1.ClientNm }}</span> {{ $t('disclosureCounselingReport.parts.pageAddressMessage4')
                        }}<span id="reportInfoEnd" style="margin-left: 30px">{{ $t('disclosureCounselingReport.parts.pageAddressMessage5') }}</span>
                    </p>
                    <table>
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title center" colspan="4">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader1') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader2') }}</span>
                                </td>
                                <td class="title center" colspan="2">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader3') }}</span>
                                </td>
                                <td class="title center" colspan="2">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader4') }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="center" colspan="4">
                                    <span v-for="(session, index) in reportStore.RepData1.Sessions" :key="index"> {{ session.SessionDate }}({{ commonStore.getConvertDictionary('CngMethodType', session.CngMethodType) }})<br /> </span>
                                </td>
                                <td class="center" colspan="2">
                                    <span>{{ useCount(reportStore.RepData1.Sessions) }}{{ $t('disclosureCounselingReport.parts.tableBody43') }}</span>
                                </td>
                                <td class="center" colspan="2">
                                    <span>{{ reportStore.RepData1.NextRsvDate }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight2">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader5') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ checkDisp(reportStore.RepData1.Status === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody1') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody2') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '3') }}{{ $t('disclosureCounselingReport.parts.tableBody3') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '4') }}{{ $t('disclosureCounselingReport.parts.tableBody4') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '5') }}{{ $t('disclosureCounselingReport.parts.tableBody5') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '6') }}{{ $t('disclosureCounselingReport.parts.tableBody6') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '7') }}{{ $t('disclosureCounselingReport.parts.tableBody7') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '8') }}{{ $t('disclosureCounselingReport.parts.tableBody8') }}<br />
                                        {{ checkDisp(reportStore.RepData1.Status === '9') }}{{ $t('disclosureCounselingReport.parts.tableBody9') }}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h5>
                        <span>{{ $t('disclosureCounselingReport.parts.tableTitle1') }}</span>
                    </h5>
                    <table>
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader6') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader7') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ isCheckDisp(reportStore.RepData1.Sleep, '1') }}{{ $t('disclosureCounselingReport.parts.tableBody10') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Sleep, '2') }}{{ $t('disclosureCounselingReport.parts.tableBody11') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Sleep, '3') }}{{ $t('disclosureCounselingReport.parts.tableBody12') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Sleep, '4') }}{{ $t('disclosureCounselingReport.parts.tableBody13') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Sleep, '5') }}{{ $t('disclosureCounselingReport.parts.tableBody14') }}<br />
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader8') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ checkDisp(reportStore.RepData1.Appetite === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody15') }} {{ checkDisp(reportStore.RepData1.Appetite === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody16') }} {{ checkDisp(reportStore.RepData1.Appetite === '3')
                                        }}{{ $t('disclosureCounselingReport.parts.tableBody17') }}
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader9') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader10') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader11') }}<br />&emsp;&emsp;&emsp;&emsp;&emsp;{{ $t('disclosureCounselingReport.parts.tableHeader12') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ $t('disclosureCounselingReport.parts.tableBody18') }}&emsp;{{ $t('disclosureCounselingReport.parts.tableBody19') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '1') }}{{ $t('disclosureCounselingReport.parts.tableBody20') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '2') }}{{ $t('disclosureCounselingReport.parts.tableBody21') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '3') }}{{ $t('disclosureCounselingReport.parts.tableBody22') }}<br />
                                        {{ $t('disclosureCounselingReport.parts.tableBody23') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '4') }}{{ $t('disclosureCounselingReport.parts.tableBody24') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '5') }}{{ $t('disclosureCounselingReport.parts.tableBody25') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '6') }}{{ $t('disclosureCounselingReport.parts.tableBody26') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '7') }}{{ $t('disclosureCounselingReport.parts.tableBody27') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '8') }}{{ $t('disclosureCounselingReport.parts.tableBody28') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Motivation, '9') }}{{ $t('disclosureCounselingReport.parts.tableBody29') }}
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader13') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader7') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '1') }}{{ $t('disclosureCounselingReport.parts.tableBody30') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '2') }}{{ $t('disclosureCounselingReport.parts.tableBody31') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '3') }}{{ $t('disclosureCounselingReport.parts.tableBody32') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '4') }}{{ $t('disclosureCounselingReport.parts.tableBody33') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '5') }}{{ $t('disclosureCounselingReport.parts.tableBody34') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '6') }}{{ $t('disclosureCounselingReport.parts.tableBody35') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '7') }}{{ $t('disclosureCounselingReport.parts.tableBody36') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '8') }}{{ $t('disclosureCounselingReport.parts.tableBody37') }}<br />
                                        {{ isCheckDisp(reportStore.RepData1.Physical, '9') }}{{ $t('disclosureCounselingReport.parts.tableBody38') }}
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader14') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ checkDisp(reportStore.RepData1.Hospital === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody39') }} {{ checkDisp(reportStore.RepData1.Hospital === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody40') }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader15') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ checkDisp(reportStore.RepData1.Medication === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody39') }} {{ checkDisp(reportStore.RepData1.Medication === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody40') }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h5>
                        {{ $t('disclosureCounselingReport.parts.tableTitle2') }}
                    </h5>
                    <table>
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader16') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData1.Subj1Contents }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader17') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ checkDisp(reportStore.RepData1.Subj1Status === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody41') }} {{ checkDisp(reportStore.RepData1.Subj1Status === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody42') }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader18') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData1.Subj1Detail }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style="margin-top: 20px">
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader16') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData1.Subj2Contents }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader17') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ checkDisp(reportStore.RepData1.Subj2Status === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody41') }} {{ checkDisp(reportStore.RepData1.Subj2Status === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody42') }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader18') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData1.Subj2Detail }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader16') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData1.Subj3Contents }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader17') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ checkDisp(reportStore.RepData1.Subj3Status === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody41') }} {{ checkDisp(reportStore.RepData1.Subj3Status === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody42') }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader18') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData1.Subj3Detail }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h5>
                        {{ $t('disclosureCounselingReport.parts.tableTitle3') }}
                    </h5>
                    <table style="height: 150px">
                        <tbody>
                            <tr>
                                <td align="left" valign="top">
                                    <p>{{ reportStore.RepData1.Prospect }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h5>
                        {{ $t('disclosureCounselingReport.parts.tableTitle4') }}
                    </h5>
                    <table style="height: 150px">
                        <tbody>
                            <tr>
                                <td align="left" valign="top">
                                    <p>{{ reportStore.RepData1.Note }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span id="reportEnd">{{ $t('disclosureCounselingReport.parts.pageAddressMessage6') }}</span>
                </section>
                <!-- 復職支援開示用報告書 -->
                <section class="reportContents medium form" v-if="!isReportReturnToWorkSupport" style="width: 1160px; min-width: 1160px;">
                    <span id="reportDate">{{ dateDisp(reportStore.RepData2.RepDate) }}</span>
                    <span id="reportFromName" class="underline">{{ $t('disclosureCounselingReport.parts.pageResponsible1') }}{{ reportStore.RepData2.AssignedNm }}</span>
                    <span id="reportToName" class="underline">{{ $t('disclosureCounselingReport.parts.pageAddress1') }}</span>
                    <p id="reportInfo">
                        {{ $t('disclosureCounselingReport.parts.pageAddressMessage1') }}<br />{{ $t('disclosureCounselingReport.parts.pageAddressMessage2') }}<br />{{ $t('disclosureCounselingReport.parts.pageAddressMessage7') }} <span class="underline">{{ reportStore.RepData2.ClientNm }}</span> {{ $t('disclosureCounselingReport.parts.pageAddressMessage8')
                        }}<span id="reportInfoEnd" style="margin-left: 30px">{{ $t('disclosureCounselingReport.parts.pageAddressMessage5') }}</span>
                    </p>
                    <table>
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title center" colspan="4">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader1') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader2') }}</span>
                                </td>
                                <td class="title center" colspan="2">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader3') }}</span>
                                </td>
                                <td class="title center" colspan="2">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader4') }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="center" colspan="4">
                                    <span v-for="(session, index) in reportStore.RepData2.Sessions" :key="index"> {{ session.SessionDate }}({{ commonStore.getConvertDictionary('CngMethodType', session.CngMethodType) }})<br /> </span>
                                </td>
                                <td class="center" colspan="2">
                                    <span>{{ useCount(reportStore.RepData2.Sessions) }}{{ $t('disclosureCounselingReport.parts.tableBody43') }}</span>
                                </td>
                                <td class="center" colspan="2">
                                    <span>{{ reportStore.RepData2.NextRsvDate }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader19') }}</span>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData2.Theme }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight2">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader20') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader21') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ checkDisp(reportStore.RepData2.Stage === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody44') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Stage === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody45') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Stage === '3') }}{{ $t('disclosureCounselingReport.parts.tableBody46') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Stage === '4') }}{{ $t('disclosureCounselingReport.parts.tableBody47') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Stage === '5') }}{{ $t('disclosureCounselingReport.parts.tableBody48') }}
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight2">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader22') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>
                                        {{ checkDisp(reportStore.RepData2.Progress === '1') }}{{ $t('disclosureCounselingReport.parts.tableBody49') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Progress === '2') }}{{ $t('disclosureCounselingReport.parts.tableBody50') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Progress === '3') }}{{ $t('disclosureCounselingReport.parts.tableBody51') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Progress === '4') }}{{ $t('disclosureCounselingReport.parts.tableBody52') }}<br />
                                        {{ checkDisp(reportStore.RepData2.Progress === '5') }}{{ $t('disclosureCounselingReport.parts.tableBody53') }}
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight3">
                                        <span>
                                            {{ $t('disclosureCounselingReport.parts.tableHeader23') }}<br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader24') }}<br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader25') }}<br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader26') }}<br /><br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader27') }}<br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader28') }}<br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader29') }}<br />
                                            {{ $t('disclosureCounselingReport.parts.tableHeader30') }}
                                        </span>
                                    </div>
                                </td>
                                <td colspan="6">{{ reportStore.RepData2.Detail }}</td>
                            </tr>
                            <tr>
                                <td class="title" rowspan="2">
                                    <span>{{ $t('disclosureCounselingReport.parts.tableHeader31') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader32') }}<br />{{ $t('disclosureCounselingReport.parts.tableHeader33') }}</span>
                                </td>
                                <td class="title">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableSubHeader1') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData2.BgEnvironment }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="title">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableSubHeader2') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData2.BgPerson }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style="margin-top: 20px">
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader34') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData2.NextTarget }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table style="margin-top: 20px">
                        <colgroup>
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <!--8列基準-->
                        <tbody>
                            <tr>
                                <td class="title" colspan="2">
                                    <div class="minHeight1">
                                        <span>{{ $t('disclosureCounselingReport.parts.tableHeader35') }}</span>
                                    </div>
                                </td>
                                <td colspan="6">
                                    <p>{{ reportStore.RepData2.Note }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span id="reportEnd">{{ $t('disclosureCounselingReport.parts.pageAddressMessage6') }}</span>
                </section>
                <!-- ハラスメント行為者行動変容開示用報告書 -->
            </section>
        </div>
    </section>
</template>
<style scoped>
    .underline {
        text-decoration: underline;
    }
</style>
